import { gql, useFragment } from "@apollo/client";

// Make sure this fragment name is unique and matches usage
export const JOURNAL_ACCOUNT_FRAGMENT = gql`
  fragment JournalAccountFragment on JournalAccount {
    journalAccountId
    tenantId
    parentAccountId
    entityId
    number
    name
    accountType
    entityType
    currency
    createdAt
    updatedAt
    deletedAt
    entity {
      ... on Account {
        accountId
        accountName
        accountNo
        accountDescription
        accountType
        automatic
        parentAccountId
        taxCodeId
        min
        max
        buExport
        serviceDateExport
        faktor2
      }
      ... on Supplier {
        supplierId
        supplierName
        originalSupplierName
        parentSupplierId
        status
        imported
        createdAt
        exportedAt
        datevAccountNumber
        vatId
        taxCodeId
        isCategory
        accountId
      }
      ... on BankAccount {
        bankAccountId
        name
        accountNumber
        type
        iban
      }
    }
    account {
      accountId
      accountName
      accountNo
      accountDescription
      accountType
      automatic
      parentAccountId
      taxCodeId
      min
      max
      buExport
      serviceDateExport
      faktor2
    }
    supplier {
      supplierId
      supplierName
      originalSupplierName
      parentSupplierId
      status
      imported
      createdAt
      exportedAt
      datevAccountNumber
      vatId
      taxCodeId
      isCategory
      accountId
    }
    bankAccount {
      bankAccountId
      name
      accountNumber
      type
      iban
    }
  }
`;

export const useGetLocalAccount = ({ accountId }: { accountId?: string }) => {
  const { data, complete } = useFragment({
    fragment: JOURNAL_ACCOUNT_FRAGMENT,
    from: {
      __typename: "JournalAccount",
      journalAccountId: accountId,
    },
  });

  return { data, complete };
};
